export type SchemaObject = object;

/**
 * JSON for an inline <script type="application/ld+json">: `<` and the JS line
 * separators are escaped so content can never close the tag or break parsing.
 */
export function serializeJsonLd(value: SchemaObject): string {
  return JSON.stringify(value)
    .replace(/</g, "\\u003c")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
}
